import { useEffect, useState } from "react";
import Aside from "../../components/Aside";
import { englishLanguage } from "../../languages/english";
import { portugueseLanguage } from "../../languages/portuguese";
import { LanguageContext } from "../../languages/languageContext";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const Root: React.FC = () => {
  const [language, setLanguage] = useState<ILanguage>(englishLanguage);
  const [languageId, setLanguageId] = useState("english");

  useEffect(() => {
    switch (languageId) {
      case "english":
        setLanguage(englishLanguage);
        break;
      case "portuguese":
        setLanguage(portugueseLanguage);
        break;
      default:
        setLanguage(englishLanguage);
        break;
    }
  }, [languageId]);

  return (
    <LanguageContext.Provider value={language}>
      <div className="block md:flex">
        <ScrollToTop />
        <Aside setLanguageId={setLanguageId} />
        <div className="w-full px-7 py-10 md:ml-[320px]">
          <Outlet />
        </div>
      </div>
    </LanguageContext.Provider>
  );
};

export default Root;
